import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Cta } from "../Cta/Cta";
import * as styles from "./SpeedbumpLink.module.css";

interface Props {
  to: string;
  target?: "_blank" | "_self";
}

export const SpeedbumpLink: React.FC<Props> = ({ children, to, ...other }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleRequestClose = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    setOpen(false);
  };

  const handleOk = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    other.target === "_blank"
      ? window.open(to, "_blank")
      : (window.location.href = to);
    setOpen(false);
  };

  useEffect(() => {
    if (
      typeof document !== "undefined" &&
      document.querySelector("#___gatsby")
    ) {
      Modal.setAppElement("#___gatsby");
    }
  }, []);

  return (
    <>
      <a href={to} {...other} data-testid="a" onClick={handleClick}>
        {children}
      </a>
      <Modal
        isOpen={open}
        onRequestClose={handleRequestClose}
        contentLabel="You are now leaving EmpriseBank.com"
        style={{
          overlay: {
            background: "rgba(0, 45, 63, 0.65)",
          },
          content: {
            border: "none",
            borderRadius: "0",
            top: "50%",
            left: "50%",
            width: "calc(100% - 1rem)",
            height: "min-content",
            maxHeight: "100vh",
            maxWidth: "950px",
            transform: "translate(-50%, -50%)",
            padding: "0",
          },
        }}
      >
        <div className={styles.headingContainer}>
          <h2>You are now leaving EmpriseBank.com</h2>
        </div>
        <div className={styles.content}>
          <p>
            You are now leaving the Emprise Bank website. Linked web pages are
            not under the control of Emprise Bank, its affiliates or
            subsidiaries. Be aware the privacy policy of the site to which you
            are going may differ from that of Emprise Bank. Emprise Bank
            provides external links as a convenience and is not responsible for
            the content or security of any linked web page.
          </p>
          <p>
            Click “OK” to continue or “CANCEL” to stay on the Emprise Bank
            website.
          </p>
          <div className={styles.ctaContainer}>
            <Cta button label="OK" onClick={handleOk} />
            <Cta button label="CANCEL" onClick={handleRequestClose} />
          </div>
        </div>
      </Modal>
    </>
  );
};
